<template>
    <b-form-select       
        :value="value"
        @input="$emit('input', $event)" 
        :options="languageOptions"
    >
    </b-form-select>
</template>

<script>
export default {
  name: "LanguagePicker",
  data() {
    return {
        languageOptions: [
            { value: 'de', text: 'Deutsch' },
            { value: 'en', text: 'English' },
            { value: 'es', text: 'Español' },
            { value: 'fr', text: 'Français' },
            { value: 'hu', text: 'Magyar' },
        ],   
    };
  },
  props: {
    value: {
      type: String,
      default: "en",
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
}
</script>